import { render, staticRenderFns } from "./getScheme.vue?vue&type=template&id=7cbdf995&scoped=true&"
import script from "./getScheme.vue?vue&type=script&lang=js&"
export * from "./getScheme.vue?vue&type=script&lang=js&"
import style0 from "./getScheme.vue?vue&type=style&index=0&id=7cbdf995&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cbdf995",
  null
  
)

export default component.exports